import {
  GraphQLObjectType,
  GraphQLNonNull,
  GraphQLID,
  GraphQLString
} from 'graphql'

export interface TeamserverPreference {
  readonly id: string
  readonly value: string
}

export const teamserverPreferenceType = new GraphQLObjectType({
  name: 'TeamserverPreference',
  fields: () => ({
    id: {
      description: 'The unique name ID for the Teamserver preference',
      type: new GraphQLNonNull(GraphQLID)
    },
    value: {
      description: 'The value for the Teamserver Preference',
      type: new GraphQLNonNull(GraphQLString)
    }
  })
})
